class ShippingInsuranceToggle extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.variantId = this.dataset.variantId;
    this.checkbox = this.querySelector('input[type="checkbox"]');

    this.checkbox.addEventListener('change', (event) => {
      event.target.checked ? this.addInsurance() : this.removeInsurance();
    });

    this.onCartUpdated = (event) => this.syncFromCart(event.detail && event.detail.cart);
    document.addEventListener('cart:updated', this.onCartUpdated);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onCartUpdated);
  }

  // Keeps the toggle in sync with the real cart state, and auto-removes
  // the insurance line if it's ever left as the cart's only item.
  syncFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    const inCart = cart.items.some((item) => String(item.variant_id) === String(this.variantId));
    this.checkbox.checked = inCart;

    if (inCart && cart.items.length === 1) {
      this.removeInsurance();
    }
  }

  addInsurance() {
    this.setLoading(true);

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.variantId]: 1
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        this.setLoading(false);
        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => {
        this.setLoading(false);
        this.checkbox.checked = false;
        console.error(e);
      });
  }

  removeInsurance() {
    this.setLoading(true);

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.variantId]: 0
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        this.setLoading(false);
        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => {
        this.setLoading(false);
        console.error(e);
      });
  }

  setLoading(isLoading) {
    this.classList.toggle('is-loading', isLoading);
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }
}
customElements.define('shipping-insurance-toggle', ShippingInsuranceToggle);
